export const setArticles =(items:any)=>({
    type: 'SET_ARTICLES',
    payload: items,
});